module.exports = __webpack_public_path__ + "img/logo1.9fa1cbbe.png";